// removed by extract-text-webpack-plugin
module.exports = {"component":"_37FFgANwD-WFyr_Y9WSgOa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/ConfigCountry/configCountry.css
// module id = 1235
// module chunks = 2